import { Link } from '@mui/material';
import { useLocalizedMatch } from '@/hooks/useLocalizedMatch';
import { getLinkActiveStyle, linkStyle } from './HeaderNavbar.style';

export const HeaderNavBarLink = ({
  link,
  nav
}: {
  link: { label: string; to: string; replace?: boolean; key: string };
  nav?: (to: string) => void;
  index: number;
}) => {
  const isActive = useLocalizedMatch(link.to) !== null;

  const onClickHandler = () => {
    if (nav) {
      nav(link.to);
    }
  };
  const item = !link.replace ? (
    <Link
      onClick={onClickHandler}
      sx={[linkStyle, getLinkActiveStyle(isActive)]}
      key={`navbarlinklink-${link.key}`}
    >
      {link.label}
    </Link>
  ) : (
    <Link sx={linkStyle} key={`navbarlink-${link.key}`} onClick={() => window.open(link.to)}>
      {link.label}
    </Link>
  );

  return <li key={link.label}>{item}</li>;
};
